export const apiRoutes = {
  dataset: {
    collection: "/v1/datasets",
    // org 스코프의 distinct 카메라 채널명 목록이다(`{channels: [...]}`). camera_channel 필터 옵션의 소스다.
    // 정적 세그먼트라 backend 는 `/{dataset_uuid}` 파라미터 라우트보다 먼저 등록한다.
    cameraChannels: "/v1/datasets/camera-channels",
    // org 전체 데이터셋 통계다(분포·총량·수집 추이·라벨). `?bucket=week|day` 는 수집 추이의 버킷
    // 단위만 정한다. status 분포만 전체 lifecycle(cancelled 제외)을 센다. 나머지 축은 available
    // 모집단을 센다.
    // 정적 세그먼트라 backend 는 `/{dataset_uuid}` 파라미터 라우트보다 먼저 등록한다.
    analytics: "/v1/datasets/analytics",
    // 목록 필터 축별 선택지의 데이터셋 수다. `?folder=` 게이트만 받고, 다른 필터와 독립이다.
    // 정적 세그먼트라 backend 는 `/{dataset_uuid}` 파라미터 라우트보다 먼저 등록한다.
    facets: "/v1/datasets/facets",
    // 목록에서 선택한 항목을 일괄 보관한다(`{dataset_uuids}`). 요청자는 행마다 생성자나 admin 이어야
    // 한다. 하나라도 아니면 전체가 403 이다. 항목마다 호출하지 않는다.
    bulkArchive: "/v1/datasets/bulk/archive",
    // 목록에서 선택한 항목을 일괄로 폴더 이동한다(조직 멤버, `{dataset_uuids, folder_uuid|null}`).
    // 단건 라우트가 없어서 1건도 이 경로로 보낸다. 정적 세그먼트라서 backend 는 `/{dataset_uuid}`
    // 파라미터 라우트보다 먼저 등록한다.
    bulkMove: "/v1/datasets/bulk/move",
    // 사람이 정리하는 폴더 트리다(2계층). 읽기와 쓰기 모두 조직 멤버가 할 수 있다.
    // 정적 세그먼트라 backend 는 `/{dataset_uuid}` 파라미터 라우트보다 먼저 등록한다.
    folders: "/v1/datasets/folders",
    folder: (folderUuid: string) => "/v1/datasets/folders/" + encodeURIComponent(folderUuid),
    // N개 공용 Dataset 의 콘텐츠를 복사해 새 Dataset 하나로 통합한다(조직 멤버, 202 + 잡).
    // 진행 상태는 `mergeJob.detail` 을 폴링한다.
    merge: "/v1/datasets/merge",
    detail: (datasetUuid: string) => "/v1/datasets/" + encodeURIComponent(datasetUuid),
    archive: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/archive",
    restore: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/restore",
    episodes: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/episodes",
    // 필터 축별 선택지 개수다. 목록과 같은 필터 파라미터를 받는다. 각 축은 그 축만 뺀 나머지
    // 조건으로 센다(조건부). 정적 세그먼트라서 backend 는 `/{episode_uuid}` 파라미터 라우트보다
    // 먼저 등록한다.
    episodeFacets: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/episodes/facets",
    // 단건 에피소드 조회다(annotation 충돌 409 후 다시 조회). 목록 항목과 같은 flat EpisodeResp 를
    // 반환한다. FE 는 이 한 건만 새로 받아 패널을 다시 초기화한다. 목록 전체는 다시 가져오지 않는다.
    episode: (datasetUuid: string, episodeUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/episodes/" +
      encodeURIComponent(episodeUuid),
    episodeFiles: (datasetUuid: string, episodeUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/episodes/" +
      encodeURIComponent(episodeUuid) +
      "/files",
    // 에피소드 전역 리뷰 부분 갱신이다(PUT, 조직 멤버). dataset_uuid 는 스코프와 가시성 게이트에 쓴다.
    // 판정은 이 에피소드를 공유하는 모든 데이터셋에 반영된다. 결함 수용·코멘트도 이 경로로 쓴다.
    episodeReview: (datasetUuid: string, episodeUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/episodes/" +
      encodeURIComponent(episodeUuid) +
      "/review",
    details: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/details",
    structure: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/structure",
    detailsRefresh: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/details/refresh",
    // 학습 진단이다. 컬렉션 요약(상태·기준 밴드 signed URL)과 에피소드 상세(위상 그리드
    // signed URL)가 있다. 미산출은 404가 아니라 200 + not_computed다. 404는 부재·가시성이다.
    diagnostics: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/diagnostics",
    // 에피소드 진단 행 페이지다. 값은 컬렉션 안에서만 뜻이 있는 스칼라다(밴드 밖 비율·큐레이션).
    // 에피소드 uuid 로 좁히는 파라미터가 없다. 그래서 단건 조회에 쓰지 않는다.
    diagnosticsEpisodes: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/diagnostics/episodes",
    episodeDiagnostics: (datasetUuid: string, episodeUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/diagnostics/episodes/" +
      encodeURIComponent(episodeUuid),
    // Dataset 에 매핑된 canonical episode 파일을 에피소드 구분 없이 나열한 flat 목록이다.
    // 데이터셋 전체를 다운로드하는 파일 단위 다운로드가 이 경로로 시작한다(에피소드 스코프
    // `episodeFiles` 와 별개). 서버는 cursor 로 page 를 나눈다(`after`·`size`). `parent` 가 없으면
    // 순서는 에피소드 순번, 파일 id 순이다. `with_download_url=true` 면 행마다 signed GET 을
    // 인라인한다(서명 비용 때문에 기본 false).
    allEpisodeFiles: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/episode-files",
    episodeFileVideoUrl: (datasetUuid: string, episodeFileUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/episode-files/" +
      encodeURIComponent(episodeFileUuid) +
      "/video-url",
    // 단건 canonical 파일을 다시 서명한다. 목록의 URL 이 만료되면 그 파일만 다시 서명한다.
    // 목록의 URL 이 null 인 사유는 409 로 확인한다. `/video-url` 과 달리 file_type 게이트가 없다.
    episodeFileDownloadUrl: (datasetUuid: string, episodeFileUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/episode-files/" +
      encodeURIComponent(episodeFileUuid) +
      "/download-url",
    // schema 밖(extra) 파일 read 경로다. 목록(parent/recursive/search/file_format)·폴더 트리·
    // 단건 1회용 signed GET URL 이 있다. 다운로드는 url 을 발급받은 뒤 client 가 직접 GET 한다.
    extraFiles: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/extra-files",
    // canonical 채널과 extra 폴더를 병합한 디렉터리 트리다(파일 미포함). Files 브라우저 트리뷰에 쓴다.
    directoryTree: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/directory-tree",
    // 곧 다운로드할 파일 묶음(최대 200)의 signed URL 을 한 번에 발급한다. 전체 다운로드는 이
    // 경로로 서명한다. 목록에 미리 서명하면 TTL 안에 모두 받지 못해 큐 뒤쪽 URL 이 만료된다.
    // read 인데 POST 를 쓰는 이유는 uuid 200개가 query string 에 들어가지 않기 때문이다.
    filesSign: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/files/sign",
    // 폴더 하나의 파일 목록이다. 서버가 episode·meta·extra 세 카탈로그를 합치고 `kind` 를 포함한다.
    // 파일 브라우저는 폴더를 펼칠 때 쓴다. 업로드 다이얼로그는 `filename` probe 로 쓴다.
    files: (datasetUuid: string) => "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/files",
    extraFileUrl: (datasetUuid: string, extraFileUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/extra-files/" +
      encodeURIComponent(extraFileUuid) +
      "/url",
    // extra 파일 write 경로다(member+). 업로드는 declare→client PUT→finalize 순서다.
    // PATCH(rename)와 DELETE 는 단건 경로를 쓴다.
    extraFilesFinalize: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/extra-files/finalize",
    extraFileDetail: (datasetUuid: string, extraFileUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/extra-files/" +
      encodeURIComponent(extraFileUuid),
    // canonical meta 파일(meta/info.json 등) read 경로다. 목록(parent/recursive/search/file_format)과
    // 단건 1회용 signed GET URL 이 있다. 계약은 extra-files 와 같다. schema 가 claim 하는 파일이라서
    // endpoint 가 따로 있다.
    metaFiles: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/meta-files",
    metaFileUrl: (datasetUuid: string, metaFileUuid: string) =>
      "/v1/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/meta-files/" +
      encodeURIComponent(metaFileUuid) +
      "/url",
    // 멤버 메모(댓글)다. GET=목록(최신순) · POST=작성(member+). 단건 DELETE 는 memoDetail 을 쓴다.
    memos: (datasetUuid: string) => "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/memos",
    memoDetail: (datasetUuid: string, memoUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/memos/" + encodeURIComponent(memoUuid),
    // full configuration 이다(active + candidate pair, revision 낙관적 동시성).
    //   - GET: 조직 멤버가 읽는다.
    //   - PUT: 생성자나 admin 이 full target 을 즉시 저장한다(직전 active 는 candidate 가 된다).
    configuration: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/configuration",
    // 변경 요청이다. 같은 body 를 받지만 active 는 바꾸지 않고 candidate 만 갱신한다(조직 멤버 누구나).
    configurationCandidate: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/configuration/candidate",
    // candidate 확정과 폐기다. confirm 은 PUT 과 같은 body 를 받고, Dataset 을 리뷰 큐에서도 뺀다.
    // discard 는 body 가 없다. 둘 다 생성자나 admin 이 POST 로 호출한다. 응답은 최신 pair 다.
    configurationCandidateConfirm: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/configuration/candidate/confirm",
    configurationCandidateDiscard: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/configuration/candidate/discard",
    // 학습 사용 중 잠금을 조회한다(조직 멤버, {locked, active_session_ids}). 참고용이라서 이 값만으로
    // 동작을 막지 않는다. 실제 강제는 write 시점의 409 가 한다.
    editLock: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/edit-lock",
    // 설정을 바꾸지 않고 검토 완료만 표시한다(body 없음, 204). 한 방향이라서 해제 라우트는 없다.
    markReviewed: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/review/mark-reviewed",
    // import 가 채우지 못한 video fps 를 리뷰어가 지정한다(생성자 또는 admin, `{fps}`). 서버는 비어
    // 있는 행만 채운다. 그래서 이미 값이 있는 dataset 에 보내면 아무것도 바꾸지 않는다(no-op).
    reviewVideoFps: (datasetUuid: string) =>
      "/v1/datasets/" + encodeURIComponent(datasetUuid) + "/review/video-fps",
  },
  members: "/v1/members",
  me: {
    current: "/v1/me",
    // 북마크 목록이다. 내가 담은 공용 Dataset 을 가진다. 항목은 flat Dataset 이다.
    //   - GET: 조직 멤버, 페이지네이션만
    //   - POST: member+, {dataset_uuid}
    //   - DELETE: admin·member, dataset_uuid 로 지정
    bookmarks: "/v1/me/bookmarks",
    // 목록에서 선택한 항목을 일괄로 담는다(member+, `{dataset_uuids}`). 이미 담긴 항목은 성공으로 센다.
    bookmarksBulk: "/v1/me/bookmarks/bulk",
    bookmarkDetail: (datasetUuid: string) => "/v1/me/bookmarks/" + encodeURIComponent(datasetUuid),
  },
  // 데이터셋 통합 잡의 진행 조회다(폴링). 큐에 넣는 경로는 `dataset.merge` 가 소유한다.
  mergeJob: {
    detail: (jobUuid: string) => "/v1/job/merge/" + encodeURIComponent(jobUuid),
  },
  // 데이터셋 업로드 잡(files 모드) 경로다. backend 경로는 /v1/job/dataset/upload 다.
  // init 이후의 lifecycle 경로를 모두 여기에 둔다.
  datasetUpload: {
    // 고를 수 있는 업로드 서버 위치다. collection 하위가 아니라 형제 경로다(잡이 아니라 카탈로그이기 때문).
    uploadLocations: "/v1/job/dataset/upload-locations",
    collection: "/v1/job/dataset/upload",
    detail: (uploadUuid: string) => "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid),
    // 아래 세 동작이 한 경로를 공유한다:
    //   - declare(POST): 파일별 signed PUT 발급
    //   - staged 목록(GET): staging prefix 실측 probe
    //   - staged 삭제(DELETE ?relative_path=)
    files: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/files",
    complete: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/complete",
    cancel: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/cancel",
    reset: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/reset",
    reprocess: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/reprocess",
    heartbeat: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/heartbeat",
    labels: (uploadUuid: string) =>
      "/v1/job/dataset/upload/" + encodeURIComponent(uploadUuid) + "/labels",
  },
  embodiment: {
    collection: "/v1/embodiments",
    detail: (embodimentUuid: string) => "/v1/embodiments/" + encodeURIComponent(embodimentUuid),
  },
  endEffector: {
    collection: "/v1/end-effectors",
    detail: (endEffectorUuid: string) => "/v1/end-effectors/" + encodeURIComponent(endEffectorUuid),
  },
  // Tip 카탈로그다. Dataset.tip_id 축이다(EE 와 직교). GET/POST /v1/tips · PATCH/DELETE /{uuid}.
  tip: {
    collection: "/v1/tips",
    detail: (tipUuid: string) => "/v1/tips/" + encodeURIComponent(tipUuid),
  },
  label: {
    collection: "/v1/labels",
    reservedKeys: "/v1/label-reserved-keys",
    // 값을 필터 드롭다운 단위로 묶는 갈래 카탈로그다(`?key=`). PageResp 가 아니라 **bare 배열**을
    // 반환한다. 항목은 소속 value 목록(`values`)도 가진다. 갈래 이름과 분류 기준의 SoT 는 DB 다.
    // 그래서 운영자가 편집한 값이 코드 상수보다 우선한다.
    categories: "/v1/label-categories",
    detail: (labelUuid: string) => "/v1/labels/" + encodeURIComponent(labelUuid),
  },
  review: {
    // GET /v1/review-options 다. 에피소드 결함 어휘와 코멘트 최대 길이를 준다
    // (정적, DB 와 관계없음). 리뷰 두 축이 함께 쓰는 계약이라서 dataset 스코프 밖에 둔다.
    options: "/v1/review-options",
    // GET /v1/label-terms 다. 자유 어휘 사전이다(자동완성 · 큐레이션 큐). 카탈로그가 받을 수 없는
    // 열린 어휘라서 `/v1/labels` 와 다른 자원이다.
    terms: "/v1/label-terms",
    // GET /v1/label-term-keys 다. 자유 어휘 사전의 키 목록이다(키 자동완성). PageResp 가 아니라
    // **bare 배열**을 반환한다.
    termKeys: "/v1/label-term-keys",
  },
  server: {
    // 현재 접속한 Registry 이미지의 환경과 deploy 빌드 태그. 인증 세션에서 한 번만 읽는다.
    info: "/v1/server-info",
  },
  auth: {
    // GET /v1/auth/mcp/codex-install.sh 다. 브라우저가 없는 클라이언트(원격 셸의 Codex)를 연결하는
    // 설치 스크립트다. 앱은 이 주소를 호출하지 않는다. 사용자가 원격 셸에서 curl 로 실행한다.
    // 그래서 명령 문자열을 조립하는 `src/auth/connectCode.ts` 가 이 경로를 쓴다. 인증 서버가
    // 소유하는 로그인·OTP 경로는 registry 경로가 아니므로 여기에 없다.
    codexInstallScript: "/v1/auth/mcp/codex-install.sh",
  },
  admin: {
    workersStatus: "/v1/admin/workers/status",
    storageCleanupTargets: "/v1/admin/storage-cleanup/targets",
    storageCleanupDryRun: "/v1/admin/storage-cleanup/dry-run",
    storageCleanupExecute: "/v1/admin/storage-cleanup/execute",
    invalidEpisodes: "/v1/admin/episodes/invalid",
    clearEpisodeInvalid: (uuid: string) =>
      "/v1/admin/episodes/" + encodeURIComponent(uuid) + "/clear-invalid",
    uploadJobs: "/v1/admin/upload-jobs",
    diagnosticJobs: "/v1/admin/diagnostic-jobs",
    diagnosticJobCapacity: "/v1/admin/diagnostic-jobs/capacity",
    diagnosticJob: (uuid: string) => `/v1/admin/diagnostic-jobs/${encodeURIComponent(uuid)}`,
    diagnosticJobWindows: (uuid: string) =>
      `/v1/admin/diagnostic-jobs/${encodeURIComponent(uuid)}/windows`,
    diagnosticJobWindowEpisodes: (uuid: string, windowUuid: string) =>
      `/v1/admin/diagnostic-jobs/${encodeURIComponent(uuid)}/windows/${encodeURIComponent(windowUuid)}/episodes`,
    uploadJob: (uuid: string) => `/v1/admin/upload-jobs/${encodeURIComponent(uuid)}`,
    uploadJobChunks: (uuid: string) => `/v1/admin/upload-jobs/${encodeURIComponent(uuid)}/chunks`,
    diagnosticJobAction: (uuid: string, action: "cancel" | "restart" | "resume") =>
      "/v1/admin/diagnostic-jobs/" + encodeURIComponent(uuid) + "/" + action,
    diagnosticScaling: "/v1/admin/workers/diagnostic-scaling",
    // 운영 지표 스냅샷을 조회하는 6경로다. 수집기(별도 프로세스)가 5분마다 기록한 PostgreSQL·
    // API pod 스냅샷을 읽기만 한다. 원시 요청 로그와 MCP tool 이벤트는 여기에 없다(Cloud Logging 소유).
    //
    // 여섯 경로 모두 `?window=` 를 **고정 어휘**(1h|6h|24h|7d|30d)로만 받는다. 자유 범위·
    // bucket·페이지네이션·정렬 파라미터는 없다. 어휘 밖 값은 422 다. 행 수는 서버가 제한한다
    // (시계열 500점 · hotspot 20건 · 지연은 surface 별 250 operation).
    observabilitySummary: "/v1/admin/observability/summary",
    observabilityDatabase: "/v1/admin/observability/database",
    observabilityTables: "/v1/admin/observability/tables",
    observabilityQueries: "/v1/admin/observability/queries",
    observabilityRuntime: "/v1/admin/observability/runtime",
    observabilityLatency: "/v1/admin/observability/latency",
    // 멈춘 in-flight import 다. 지금 어느 워커도 잡고 있지 않은 업로드 잡이다. 워커가 죽었거나 종료하며
    // 잡을 반납했다. 반납한 잡은 보통 다음 claim 에서 목록에서 사라진다. 수가
    // 적어서 페이지네이션 없이 `{jobs: [...]}` 로 한 번에 온다. 다시 큐에 넣을 때 서버는 staging
    // 바이트를 재사용하고 잡을 UPLOADED 로 되돌린다.
    uploadJobsRecovery: "/v1/admin/upload-jobs/recovery",
    uploadJobReprocess: (uploadUuid: string) =>
      "/v1/admin/upload-jobs/" + encodeURIComponent(uploadUuid) + "/reprocess",
    // 멤버 목록이다(identity + 등급 + GitHub 팀명, list[MemberResp]). 담당자 picker 후보의 소스다.
    // org 디렉터리와 달리 display_name 을 직접 준다. admin 게이트다.
    members: "/v1/admin/members",
    // 멤버 등급 설정이다(PATCH /{uuid}). admin 게이트다.
    memberDetail: (memberUuid: string) => "/v1/admin/members/" + encodeURIComponent(memberUuid),
    // org 디렉터리다(GitHub org 멤버/팀을 실시간으로 조합하고 registry 와 조인). admin 게이트다.
    orgDirectory: "/v1/admin/org/directory",
    // TrainingGroup 매핑 CRUD, GitHub 팀 매핑, training-infra Group 후보 프록시다. admin 게이트다.
    // 경로는 backend 계약을 그대로 따른다(/v1/admin/training-groups, hyphen·복수).
    trainingGroups: "/v1/admin/training-groups",
    trainingGroupDetail: (groupUuid: string) =>
      "/v1/admin/training-groups/" + encodeURIComponent(groupUuid),
    trainingGroupGithubTeams: (groupUuid: string) =>
      "/v1/admin/training-groups/" + encodeURIComponent(groupUuid) + "/github-teams",
    trainingGroupGithubTeamDetail: (groupUuid: string, githubTeamName: string) =>
      "/v1/admin/training-groups/" +
      encodeURIComponent(groupUuid) +
      "/github-teams/" +
      encodeURIComponent(githubTeamName),
    // 유저 → TrainingGroup 명시 매핑이다(a축). github_user_id 가 바뀌지 않는 키다(가입 전에도 매핑).
    trainingGroupMembers: (groupUuid: string) =>
      "/v1/admin/training-groups/" + encodeURIComponent(groupUuid) + "/members",
    trainingGroupMemberDetail: (groupUuid: string, githubUserId: number) =>
      "/v1/admin/training-groups/" +
      encodeURIComponent(groupUuid) +
      "/members/" +
      encodeURIComponent(String(githubUserId)),
    // training-infra Group 매핑 후보다(라이브 프록시).
    trainingGroupCandidates: "/v1/admin/training-groups/candidates",
    // member↔training workspace 매핑이다(개인 스코프의 근거). 후보 목록·생성·rename 은 admin
    // training-workspaces 경계에 있다. 매핑 CRUD 는 member 하위 리소스다.
    trainingWorkspaces: "/v1/admin/training-workspaces",
    trainingWorkspaceDetail: (trainingWorkspaceId: string) =>
      "/v1/admin/training-workspaces/" + encodeURIComponent(trainingWorkspaceId),
    // 선점 스냅샷과 training live 를 비교한다(읽기 전용 진단, 4버킷).
    trainingWorkspacesSyncStatus: "/v1/admin/training-workspaces/sync-status",
    // 선점 스냅샷 갱신(빈 body) 또는 소유자 이전({member_uuid})이다. 이전은 즉시 전체에 반영된다.
    trainingWorkspaceRemap: (trainingWorkspaceId: string) =>
      "/v1/admin/training-workspaces/" + encodeURIComponent(trainingWorkspaceId) + "/remap",
    // research 공용 workspace 등록이다(선점자 없이 모든 research 멤버에게 열린 workspace).
    // 등록 목록과 등록은 컬렉션 경로이고, 해제는 workspace id 하위 경로다.
    trainingSharedWorkspaces: "/v1/admin/training-shared-workspaces",
    trainingSharedWorkspaceDetail: (trainingWorkspaceId: string) =>
      "/v1/admin/training-shared-workspaces/" + encodeURIComponent(trainingWorkspaceId),
    memberTrainingWorkspaces: (memberUuid: string) =>
      "/v1/admin/members/" + encodeURIComponent(memberUuid) + "/training-workspaces",
    memberTrainingWorkspaceDetail: (memberUuid: string, trainingWorkspaceId: string) =>
      "/v1/admin/members/" +
      encodeURIComponent(memberUuid) +
      "/training-workspaces/" +
      encodeURIComponent(trainingWorkspaceId),
  },
  // 팀 스코프 training read 다(registry 가 actor 의 팀에서 스코프를 도출). 멤버 누구나 열람한다.
  // me 스코프는 Admin 이 member 에 매핑한 개인 workspace 가 기준이다(team 과 토글). 스코프는 BE 가
  // actor 에서 도출한다. FE 는 group/workspace 스코프를 직접 다루지 않는다.
  // 와이어 경로 세그먼트는 BE 계약상 `group`(팀 스코프)·`me`(개인 스코프)다.
  training: {
    // ---- 팀/개인 스코프 read (browse 축) ----
    // 팀(그룹) 데이터셋만 registry 축이다. 선택한 group_uuid 를 path 로 보낸다(나머지 팀 read 는
    // training 축의 고정 경로). group_uuid 의 소스는 /v1/me 의 linked_training_groups[].group_uuid 다.
    teamDatasets: (groupUuid: string) =>
      "/v1/training/group/" + encodeURIComponent(groupUuid) + "/datasets",
    // 세션 목록(내/팀)이다. 선점 workspace 스코프의 rich 행(진행률·노트·선점자 임베드)을 서버가
    // 페이징한다(PageResp). 팀은 ?group_uuid= 쿼리로 그룹 하나에 좁힌다(미지정=actor 팀 전체).
    meSessions: "/v1/training/me/sessions",
    groupSessions: "/v1/training/group/sessions",
    // 데이터셋별 학습 사용 수다. 필터 드롭다운이 옵션 옆에 함께 표시한다. registry 제출 저널의
    // 집계라서 training 을 호출하지 않는다. 스코프는 세션 목록과 같은 규칙으로 해석한다.
    meDatasetUsage: "/v1/training/me/dataset-usage",
    groupDatasetUsage: "/v1/training/group/dataset-usage",
    // 내 스코프의 활성 학습·평가 건수 하나다. 목록 라우트로 같은 수를 얻으면 항목 조립 비용도
    // 든다. 그래서 사이드바 배지 전용 집계 경로를 따로 쓴다.
    meActiveCounts: "/v1/training/me/active-counts",
    teamMembers: "/v1/training/group/members",
    teamWorkspaces: "/v1/training/group/workspaces",
    teamExperiments: "/v1/training/group/experiments",
    meWorkspaces: "/v1/training/me/workspaces",
    sharedExperiments: "/v1/training/shared/experiments",
    meExperiments: "/v1/training/me/experiments",
    // actor 가 멤버인 모든 training 그룹이다({group_uuid, name}). team 스코프 화면의 그룹 드롭다운
    // 소스다. linked_training_groups(training_group_id 가 연결된 팀만 담은 부분집합)의 상위집합이다.
    // 나머지 팀 browse 엔드포인트는 선택한 group_uuid 를 쿼리로 받아 그 그룹만 스코프한다
    // (미지정=actor 집계).
    meGroups: "/v1/training/me/groups",

    // ---- submit 준비 옵션 ----
    // 초기 옵션 묶음이다(workspace·branch·trainer image·eval scenario·resource 기본값). 일부가 실패하면
    // 서버는 응답의 unavailable[] 에 담는다. experiment 후보는 me/experiments(meExperiments) 조회를 재사용한다.
    submitOptions: "/v1/training/submit-options",
    // POST=experiment 생성. browse 의 group/me experiments 와 다른 경로다.
    submitExperiments: "/v1/training/experiments",
    // PATCH=실험 노트(description) 수정. 이름은 바꿀 수 없다.
    submitExperimentDetail: (experimentId: string) =>
      "/v1/training/experiments/" + encodeURIComponent(experimentId),
    // branch 를 선택하면 config 목록 / 단건 본문을 조회한다. ref 에 `/` 가 들어갈 수 있어서
    // query 스타일 경로를 쓴다.
    branchConfigs: "/v1/training/learning-core/branch-configs",
    branchConfig: "/v1/training/learning-core/branch-config",
    // ref 에서 도달할 수 있는 최근 커밋이다. 제출할 때 고정할 커밋의 선택지다.
    // `since=<full sha>` 면 head 에서 그 커밋까지(포함) 온다. 그 커밋이 창(`limit`) 밖이면
    // `since_reached=false` 와 최신 `limit` 개가 온다.
    branchCommits: "/v1/training/learning-core/branch-commits",

    // ---- 세션 제출·상세·명령 ----
    // POST=제출 전용(Idempotency-Key 헤더 필수). 목록은 meSessions/groupSessions 가 담당한다.
    sessions: "/v1/training/sessions",
    // POST=제출할 때 주입될 mux override 미리보기(부작용 없음). Confirm 단계 diff 의 소스다.
    sessionsPreviewOverrides: "/v1/training/sessions/preview-overrides",
    // POST=제출 입력 config 경고 검사(부작용 없음, 항상 200). finding 은 모두 경고라서 제출을
    // 막지 않는다. Confirm 단계에서 미리 호출해 참고용으로 표시한다.
    sessionsValidate: "/v1/training/sessions/validate",
    // GET=rich 상세 · PATCH=rename. `{id}`는 training session id다. 가시성은 workspace 선점
    // 스코프를 따른다(본인+같은 팀, 밖이면 404).
    session: (sessionId: string) => "/v1/training/sessions/" + encodeURIComponent(sessionId),
    // GET=세션의 입력 Dataset 한 쪽(`?page=&size=&search=`). 순서는 목록 행의 대표 순서다.
    sessionDatasets: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/datasets",
    sessionCancel: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/cancel",
    sessionRetry: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/retry",
    // epoch 체크포인트 다운로드 URL(signed).
    sessionPolicyDownload: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/policies/download",

    sessionRawCheckpoints: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/raw-checkpoints",
    sessionRawCheckpointDownload: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/raw-checkpoints/download",
    sessionCompanionFiles: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/companion-files",
    sessionCompanionFileDownload: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/companion-files/download",

    // ---- 예약 실행(스케줄) ----
    // POST=생성(제출 전문 + 반복 축) · GET=목록. 목록에는 `experiment_id` 가 **필수**다.
    // 필터 없는 목록은 아래 operations 경로만 자격 게이트 뒤에서 제공한다.
    schedules: "/v1/training/schedules",
    // GET=Operations > Schedule 목록(전역 + 스케줄별 실행 중 세션 수).
    // 자격(admin 또는 research 멤버)이 없으면 403, 상류가 배포되지 않았으면 503 이다.
    scheduleOperations: "/v1/training/schedules/operations",
    // GET=단건 · PATCH=수정 · DELETE=해제(204, 상류 soft-cancel).
    schedule: (scheduleId: string) => "/v1/training/schedules/" + encodeURIComponent(scheduleId),
    schedulePause: (scheduleId: string) =>
      "/v1/training/schedules/" + encodeURIComponent(scheduleId) + "/pause",
    scheduleResume: (scheduleId: string) =>
      "/v1/training/schedules/" + encodeURIComponent(scheduleId) + "/resume",
    // GET=저장된 제출 전문(step·dataset·config 본문·eval 파라미터).
    scheduleRecipe: (scheduleId: string) =>
      "/v1/training/schedules/" + encodeURIComponent(scheduleId) + "/recipe",
    // GET=발화 이력·예정 미리보기(최신 scheduled_for 순).
    scheduleOccurrences: (scheduleId: string) =>
      "/v1/training/schedules/" + encodeURIComponent(scheduleId) + "/occurrences",

    // ---- 종료 알림(수신 설정·수신자) ----
    // GET=기본 설정 + 수신자 전체 상태 · PATCH=기본 설정 부분 수정. workspace 는 화면이 고르지
    // 않고 내 스코프에서 도출한다(docs/rules.md §15). 스코프 밖과 부재는 모두 404 다.
    workspaceNotifications: (workspaceId: string) =>
      "/v1/training/workspaces/" + encodeURIComponent(workspaceId) + "/notifications",
    // POST=수신자 등록(201). 이메일이 식별자라서 한 workspace 에 같은 이메일은 하나뿐이다.
    workspaceNotificationRecipients: (workspaceId: string) =>
      "/v1/training/workspaces/" + encodeURIComponent(workspaceId) + "/notifications/recipients",
    // PATCH=수신자 부분 수정 · DELETE=해제(204). 이 앱은 PATCH 만 쓴다. 끄기는 삭제가 아니라
    // enabled=false 다. 그래서 다시 켤 수 있고 last_error 이력이 남는다.
    workspaceNotificationRecipient: (workspaceId: string, recipientId: string) =>
      "/v1/training/workspaces/" +
      encodeURIComponent(workspaceId) +
      "/notifications/recipients/" +
      encodeURIComponent(recipientId),

    // ---- 세션 관리 ----
    sessionsBulk: "/v1/training/sessions/bulk",
    sessionClone: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/clone",
    // POST=체크포인트에서 이어서 학습. 본문이 없다. 이어갈 지점(최신 체크포인트·seed·learning_core
    // SHA)은 모두 training 이 정한다. training 은 새 세션을 만들고 부모 MLflow run 을 이어 쓴다.
    sessionResume: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/resume",
    sessionSteps: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/steps",
    // GET=재학습(retrain) 가능 여부. 세션에 재개 가능한 raw 체크포인트가 있는지만 알려 준다.
    // URI 는 담지 않는다. 제출도 세션 id 만 받는다.
    sessionRetrainAvailability: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/retrain-availability",

    // ---- 세션별 평가 ----
    // GET=eval-run 목록 · POST=평가 트리거(session-centric).
    sessionEvalRuns: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/eval-runs",
    sessionEvalSummary: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/eval-summary",
    // 세션이 만든 체크포인트 목록이다. 다운로드 경로가 없다. epoch은 문자열(`epoch_050`)이다.
    sessionCheckpoints: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/policies",
    sessionProgress: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/progress",
    // 세션 학습 로그를 커서로 폴링한다(?since=&limit=). held-open 스트림이 아니다.
    sessionLogs: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/logs",
    // 학습 지표 key 목록과 마지막 값이다. run 이 아직 없으면 빈 응답이다(오류 아님).
    sessionMetrics: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/metrics",
    // 지표 1개의 step 시계열이다(?metric_key=). 모르는 key 이거나 run 이 없으면 points 가 빈다.
    sessionMetricsHistory: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/metrics-history",
    // 실패 원인 진단이다(분류·권장 조치). 분류 전이면 분류 필드가 모두 null 이다.
    sessionDiagnostics: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/diagnostics",
    // 진행 중 세션의 pod·GPU 순간 지표다. Running pod 가 없으면 pods 가 빈다(오류 아님).
    sessionGpuMetrics: (sessionId: string) =>
      "/v1/training/sessions/" + encodeURIComponent(sessionId) + "/gpu-metrics",

    // ---- 정책 카탈로그 ----
    teamPolicies: "/v1/training/group/policies",
    mePolicies: "/v1/training/me/policies",
    // POST=체크포인트→정책 등록.
    policies: "/v1/training/policies",
    // GET=단건(스코프 밖이면 404).
    policy: (policyId: string) => "/v1/training/policies/" + encodeURIComponent(policyId),
    // POST=정책-중심 평가(scenario×seed → eval-run 생성).
    policyEvaluate: (policyId: string) =>
      "/v1/training/policies/" + encodeURIComponent(policyId) + "/evaluate",
    // GET=요청자가 바로 다운로드하는 1시간 서명 URL. 공유 링크와 달리 기록이 남지 않는다.
    policyDownload: (policyId: string) =>
      "/v1/training/policies/" + encodeURIComponent(policyId) + "/download",

    // ---- 공유 링크 ----
    // POST=발급(링크 원문은 이 응답에만 있다) · GET=내가 발급한 링크 목록.
    myShareLinks: "/v1/training/me/share-links",
    // POST=같은 파일로 새 링크(발행자 본인만).
    myShareLinkReissue: (shareLinkUuid: string) =>
      "/v1/training/me/share-links/" + encodeURIComponent(shareLinkUuid) + "/reissue",
    // GET=조직 전체 목록(admin).
    shareLinks: "/v1/training/share-links",
    // DELETE=폐기(발행자 또는 admin).
    shareLink: (shareLinkUuid: string) =>
      "/v1/training/share-links/" + encodeURIComponent(shareLinkUuid),

    // ---- eval-run (실행 단위) ----
    // 결과 목록은 Policy 카탈로그와 같은 me/group 스코프를 쓴다. Team 은 group_uuid 로
    // 페이지 상단에서 고른 그룹 하나로 좁힌다.
    meEvalRuns: "/v1/training/me/eval-runs",
    teamEvalRuns: "/v1/training/group/eval-runs",
    evalRunSummaries: "/v1/training/eval-runs/summaries",
    evalBaseline: "/v1/training/eval-baseline",
    evalRun: (evalRunId: string) => "/v1/training/eval-runs/" + encodeURIComponent(evalRunId),
    evalRunProgress: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/progress",
    // 에피소드 판정과 term 분포다(박스플롯 소스). 산출 전이면 빈 결과다.
    evalRunSuccessTerms: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/success-terms",
    evalRunMetrics: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/metrics",
    // 커서로 폴링한다(?since=&limit=). held-open 스트림이 아니다.
    evalRunLogs: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/logs",
    evalRunFailedVideos: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/failed-videos",
    evalRunRecordedVideos: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/recorded-videos",
    evalRunCancel: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/cancel",
    evalRunRerun: (evalRunId: string) =>
      "/v1/training/eval-runs/" + encodeURIComponent(evalRunId) + "/rerun",

    // ---- eval scenario (전역 카탈로그, auth-only) ----
    // GET=목록(?active_only=).
    evalScenarios: "/v1/training/eval-scenarios",
    // 평가 설정 하나로 seed 별 scenario 를 찾거나 생성한다(member-write). 이름·해시 규칙은
    // training-infra 가 소유한다. 그래서 프론트는 설정만 전달한다.
    evalScenarioReconcile: "/v1/training/eval-scenarios/reconcile",
    evalScenarioImages: "/v1/training/eval-scenarios/images",
    evalScenarioImageMetadata: (tag: string) =>
      "/v1/training/eval-scenarios/images/" + encodeURIComponent(tag) + "/metadata",

    // ---- mlflow 작은 텍스트 아티팩트(config·box-plot 텍스트). auth-only. ----
    mlflowArtifactText: "/v1/training/mlflow-artifacts/text",

    // ---- GPU 가시성 (training-infra proxy, 조회 전용) ----
    // 클러스터 GPU 가용량 스냅샷이다. 로그인한 조직 멤버는 모든 workspace 를 본다(세션 목록의 선점
    // 스코프와 다른 축). `?fresh=true` 는 upstream 캐시(TTL 15s)를 건너뛰고 GKE·k8s 를 직접 읽는다.
    // 그래서 사람이 누른 새로고침에만 붙인다. 자동 폴링에 붙이면 upstream 에 부하가 생긴다.
    gpuCapacity: "/v1/training/gpu/capacity",
    // 기간 집계 두 개다. 둘 다 `start`·`end`(aware UTC ISO)가 필수이고, 버킷은 UTC 일이다.
    // `end <= start` 와 92일을 넘는 기간은 서버가 upstream 을 호출하기 전에 422 로 거절한다.
    // cluster 는 클러스터 전체의 held·used·idle 추세다. workspaces 는 workspace 별 GPU-hours·비용과
    // 일별·작업 종류·계층 분해다. 두 집계는 출처가 다르다. 그래서 "사용" 합이 서로 같지 않다.
    gpuUsageCluster: "/v1/training/gpu/usage/cluster",
    gpuUsageWorkspaces: "/v1/training/gpu/usage/workspaces",
    // 사람별 GPU 한도와 현재 점유다. 한 행은 한 사람이 선점한 workspace 들을 합친 값이다. 내역은
    // 응답의 `workspaces` 에 있다. 쿼리 파라미터는 없다. 사람 축에서 group 으로 좁히면, 그 사람의
    // 총합이 아닌 값이 총합 필드에 들어간다. 지금 적용 중인 한도는 `gpu_limit` 이 아니라
    // `effective_gpu_limit` 이다(요일·시간대 스케줄).
    gpuMemberQuotas: "/v1/training/gpu/member-quotas",
    // ---- 한도 상향 요청 (registry 소유 레코드, training-infra 프록시 아님) ----
    // 조회는 조직 스코프다. 같은 조직이면 팀이 달라도 다른 사람의 요청을 본다(요청자 포함).
    // 좁히기는 `requested_by_member_uuid`(행에 고정된 접수자) 축으로 한다. 선점자는 어드민 재매핑으로
    // 바뀔 수 있고, 그러면 과거 이력의 귀속도 모두 바뀐다. 접수는 선점자 본인 또는 admin 이 한다.
    gpuQuotaRequests: "/v1/training/gpu/quota-requests",
    // 철회는 요청자 본인이, 종결(applied/rejected)은 admin 이 한다. 응답의 can_* 로 판정한다.
    gpuQuotaRequestCancel: (requestUuid: string) =>
      "/v1/training/gpu/quota-requests/" + encodeURIComponent(requestUuid) + "/cancel",
    gpuQuotaRequestResolve: (requestUuid: string) =>
      "/v1/training/gpu/quota-requests/" + encodeURIComponent(requestUuid) + "/resolve",

    // ---- 연구자 노트 (training-infra proxy, entity=session/policy/eval_run) ----
    // bulk read = ?entity_type=&entity_ids=<csv>. 단건 GET/PUT/DELETE = /{entity_type}/{entity_uuid}.
    notes: "/v1/training/notes",
    note: (entityType: string, entityUuid: string) =>
      "/v1/training/notes/" + encodeURIComponent(entityType) + "/" + encodeURIComponent(entityUuid),
  },
  // SAM 어노테이션 프록시다(BE docs/specs/sam-annotation-proxy.md). registry 는 GPU/디코더 없이
  // training-infra 로 중계한다. 두 축이 있다: dataset 스코프 read·대화형, set 스코프 CRUD.
  // frame-meta/frame.png/preview 는 상태를 바꾸지 않지만 training 용량을 쓴다. 그래서 member+ 게이트다.
  trainingAnnotation: {
    bundleIndex: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/bundle-index",
    bundleFrames: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/bundle-frames",
    bundleFrame: (setUuid: string, frameUuid: string) =>
      "/v1/training/annotation/sets/" +
      encodeURIComponent(setUuid) +
      "/bundle-frames/" +
      encodeURIComponent(frameUuid),
    bundleImports: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/bundle-imports",
    bundleFinalize: (datasetUuid: string, setUuid: string) =>
      "/v1/training/datasets/" +
      encodeURIComponent(datasetUuid) +
      "/annotation/bundle-imports/" +
      encodeURIComponent(setUuid) +
      "/finalize",
    // 카메라→에피소드 트리다. 이 조회만으로 Dataset 이 training 에 lazy 등록된다(준비 전이면 409).
    structure: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/structure",
    // (camera, episode) 원본 mp4 의 서명 URL 이다(TTL 1h). <video> 가 직접 사용한다.
    videoUrl: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/video-url",
    frameMeta: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/frame-meta",
    // 단건 프레임 PNG 바이너리다. 인증 헤더가 필요해서 <img src> 에 직접 연결할 수 없다. blob 으로 받는다.
    framePng: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/frame.png",
    // 포인트 프롬프트로 마스크를 미리 본다. 429+Retry-After 는 정상 경로다(GPU holder 가 요청을 직렬화).
    preview: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/preview",
    // GET=목록(최신순, materialize 임베드) · POST=draft 생성.
    sets: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/sets",
    // GET=단건 summary · PATCH=이름 변경 · DELETE=revision CAS soft delete.
    set: (setUuid: string) => "/v1/training/annotation/sets/" + encodeURIComponent(setUuid),
    setFrames: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/frames",
    setFrame: (setUuid: string, frameId: string) =>
      "/v1/training/annotation/sets/" +
      encodeURIComponent(setUuid) +
      "/frames/" +
      encodeURIComponent(frameId),
    trackingConditioning: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/tracking-conditioning",
    // fingerprint 를 고정하고 materialize 잡을 큐에 넣는다. committed 는 바꿀 수 없다. 다시 편집하려면
    // 새 draft 를 만든다.
    setCommit: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/commit",
    // failed 잡을 명시적으로 재시도한다(202). queued/running/succeeded 는 409 다.
    setMaterialize: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/materialize",
    // 렌더가 끝난 세트의 keyframe PNG/YAML 페이지다(`<camera>/<file>` + 서명 URL, TTL 1h).
    // 바이트는 storage 에서 직접 받는다.
    setFiles: (setUuid: string) =>
      "/v1/training/annotation/sets/" + encodeURIComponent(setUuid) + "/files",
    // 트래킹 직결 WS 의 connection 을 발급한다. registry 는 WS 를 중계하지 않는다. ws_url 과
    // 서명 video URL(TTL 6h)만 준다. 브라우저가 training 에 직접 연결한다.
    connection: (datasetUuid: string) =>
      "/v1/training/datasets/" + encodeURIComponent(datasetUuid) + "/annotation/connection",
  },
} as const;
